import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { State } from "@shared/types/graphqlGenerated";

const GET_STATES_INFO = gql`
  query StatesInfo_Shared_Query {
    viewer {
      states {
        id
        name
        abbr
      }
    }
  }
`;

interface StatesData {
  viewer: {
    states: State[];
  };
}

const useStatesInfoQuery = (options?: QueryHookOptions<StatesData>) => {
  return useQuery<StatesData>(GET_STATES_INFO, options);
};

export type { StatesData };
export { GET_STATES_INFO, useStatesInfoQuery };
